export default __webpack_public_path__ + "static/media/seller.e8aa8954.svg";